import { AxiosResponse } from "axios";

import api from "utils/apiClient";
import ROUTES from "constants/routes";
import {
  ConfirmBirthdateData,
  LoginData,
  PasswordRecoveryData,
  PasswordUpdateData,
  RefreshTokenData,
  TokenLoginData,
  AuthInfo,
  ResendSmsData,
  ConfirmPhoneData,
  LoginResponseData,
} from "types";

export const login = (
  data: LoginData
): Promise<AxiosResponse<LoginResponseData>> => {
  return api.post("/login", data);
};

export const tokenLogin = ({
  token,
}: TokenLoginData): Promise<AxiosResponse<AuthInfo>> => {
  return api.post("/login-by-token", { token });
};

export const refreshToken = (data: RefreshTokenData) => {
  return api.post(
    "/refresh-token",
    {},
    {
      headers: {
        Authorization:"Bearer "+ data.refreshToken,
      },
    }
  );
};

export const confirmPhone = ({ type, ...data }: ConfirmPhoneData) => {
  switch (type) {
    case ROUTES.LOGIN:
    case ROUTES.TOKEN_LOGIN:
      return api.post("/login/confirm-code", data);
    case ROUTES.PASSWORD_RECOVERY:
      return api.post("/restore-password/confirm-code", data);
    default:
      return Promise.reject("Invalid type");
  }
};

export const restorePassword = (data: PasswordRecoveryData) => {
  return api.post("/restore-password", data);
};

export const resendSms = ({ type, token }: ResendSmsData) => {
  switch (type) {
    case ROUTES.LOGIN:
    case ROUTES.TOKEN_LOGIN:
      return api.post("/login/resend-sms", { token });
    case ROUTES.PASSWORD_RECOVERY:
      return api.post("/restore-password/resend-sms", { token });
    default:
      return Promise.reject("Invalid type");
  }
};

export const confirmBirthdate = ({
  birthdate,
  accessToken,
}: ConfirmBirthdateData) => {
  return api.post(
    "/restore-password/check-birthday",
    {
      birthday: `${birthdate.slice(0, 2)}.${birthdate.slice(
        2,
        4
      )}.${birthdate.slice(4, 8)}`,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const resetPassword = ({
  password,
  accessToken,
}: PasswordUpdateData) => {
  return api.put(
    "/set-password",
    { password },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};
